import { render, staticRenderFns } from "./SDD.vue?vue&type=template&id=d29814a0&scoped=true&"
import script from "./SDD.vue?vue&type=script&lang=js&"
export * from "./SDD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29814a0",
  null
  
)

export default component.exports